/* loaded by smart-asset */
export default require("./assets/arrow.i.svg")